import { getWeekday } from '@nx-smartmonkey/shared/helpers';
import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useMutation } from '@tanstack/react-query';

import { routeService } from '../../../application/RouteService';
import { Route } from '../../../domain/route/Route';
import { useRetrieveActiveLanguage } from '../../../hooks/translations/useRetrieveActiveLanguage';

type UseCreateInitialRouteResponseProps = ServiceResponse<() => void, Route>;

// Hooks act as 'Adapter' layer.
export const useCreateInitialRoute = (): UseCreateInitialRouteResponseProps => {
  const { activeLanguage } = useRetrieveActiveLanguage();

  const { isLoading, data, isSuccess, isError, mutate } = useMutation<Route, unknown, void>((): Promise<Route> => {
    const initialRouteLabel = getWeekday({
      date: new Date(),
      language: activeLanguage,
    });
    return routeService.createRoute({
      label: initialRouteLabel,
      execution_date: new Date(),
    });
  });

  return {
    error: isError,
    success: isSuccess,
    isLoading: isLoading,
    run: mutate,
    data,
  };
};
